import { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export function GradientMask({ side, visible }: { side: 'left' | 'right'; visible: boolean }) {
  const isLeft = side === 'left'
  return (
    <div
      className={cn(
        'pointer-events-none absolute top-0 z-interactive hidden h-full w-[280px] transition-opacity duration-300 lg:block',
        isLeft ? 'left-0' : 'right-0',
        visible ? 'opacity-100' : 'opacity-0',
      )}
      style={{
        background: `linear-gradient(${isLeft ? '90deg' : '-90deg'}, rgb(18, 18, 22) 21.85%, rgba(18, 18, 22, 0) 100%)`,
      }}
    />
  )
}

type ScrollArrowProps = {
  side: 'left' | 'right'
  visible: boolean
  onClick: () => void
  icon: ReactNode
  variant?: 'default' | 'flush'
  className?: string
  buttonClassName?: string
}

export function ScrollArrow({
  side,
  visible,
  onClick,
  icon,
  variant = 'default',
  className,
  buttonClassName,
}: ScrollArrowProps) {
  return (
    <div
      className={cn(
        'group pointer-events-none absolute top-0 z-floating hidden h-full w-24 items-center justify-center transition-opacity duration-300 lg:flex',
        side === 'left'
          ? variant === 'flush'
            ? 'left-0'
            : 'left-4 md:left-[36px] lg:left-6'
          : variant === 'flush'
            ? 'right-0'
            : 'right-4 md:right-[36px] lg:right-6',
        visible ? 'opacity-100' : 'pointer-events-none opacity-0',
        className,
      )}
    >
      <div
        className={cn(
          'pointer-events-auto grid size-16 cursor-pointer place-items-center rounded-full bg-white/80 transition-colors duration-200 group-hover:bg-white',
          !visible && 'pointer-events-none',
          buttonClassName,
        )}
        onClick={onClick}
      >
        {icon}
      </div>
    </div>
  )
}
